import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f45b60ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["points", "strokeWidth"]
const _hoisted_3 = {
  key: 0,
  class: "icon",
  "data-transition-enter": ""
}
const _hoisted_4 = {
  key: 1,
  class: "title",
  "data-transition-enter": ""
}
const _hoisted_5 = {
  key: 2,
  class: "description",
  "data-transition-enter": ""
}

import { ref, nextTick, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import gsap from 'gsap'

import AudioManager, { AUDIO_ID } from '@/core/audio/AudioManager'
import AppService from '@/services/AppService'
import DesktopActivity from '@webgl/activities/desktop/DesktopActivity'

import frames from '@/utils/FrameToTime'
import { useGameState } from '@/services/composition'


export default /*#__PURE__*/_defineComponent({
  props: {
  icon: {
    type: String
  },
  title: {
    type: String
  },
  description: {
    type: String
  },
  hover: {
    type: Boolean,
    default: false
  },
  strokeWidth: {
    type: Number,
    default: 1
  },
},
  setup(__props) {

const props = __props

const state = useGameState()

const { t } = useI18n()




const panel = ref(null)
const onEnter = (el: HTMLElement, onComplete: gsap.Callback) => {
  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(panel.value, { yPercent: 100, }, {yPercent: 0, duration: frames(30), ease: 'quint.out' })
  tl.fromTo($('[data-transition-enter]'), { yPercent: 100, opacity: 0, }, {yPercent: 0, opacity: 1, duration: frames(30), ease: 'quint.out', stagger: 0.1 }, 0.2)

  AudioManager.play(AUDIO_ID.UI_POP_IN)
}

const onLeave = (el: HTMLElement, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.to(panel.value, { yPercent: 100, duration: frames(30), ease: 'quint.in' })
  console.log(state.value.context.hotspotHovered)
  if (state.value.context.hotspotHovered !== - 1) {
    tl.timeScale(10)
  }
}

const handleClick = () => {
  (AppService.glapp.activity as DesktopActivity).hotspots.handleClick()
}

const backgroundData = ref({ viewBox: { minX: 0, minY: 0, width: 0, height: 0 }, polygon: { points: "" } })
const root = ref(null)
const background = ref(null)
const borderWidth = ref(48)

onMounted(async () => {
  resizeObserver.observe(root.value)
  resize()
})

onUnmounted(() => {
  resizeObserver.disconnect()
})

const resize = async () => {
  await nextTick()
  const elBCR = background.value.getBoundingClientRect()
  let points = getShape({ topLeftRatio: 1, bottomRightRatio: 0, bottomLeftRatio: 0, topRightRatio: 0 })
  
  backgroundData.value = {
    viewBox: {
      minX: 0,
      minY: 0,
      width: Math.round(elBCR.width),
      height: Math.round(elBCR.height)
    },
    polygon: {
      points
    }
  }
}
const resizeObserver = new ResizeObserver(resize)

const getShape = ({ topLeftRatio = 0, topRightRatio = 0, bottomRightRatio = 0, bottomLeftRatio = 0 }) => {
  const elBCR = background.value.getBoundingClientRect()
  return `
      ${props.strokeWidth + (borderWidth.value * topLeftRatio)} ${props.strokeWidth}, 
      ${elBCR.width - props.strokeWidth - (borderWidth.value * topRightRatio)} ${props.strokeWidth},
      ${elBCR.width - props.strokeWidth} ${props.strokeWidth + (borderWidth.value * topRightRatio)},
      ${elBCR.width - props.strokeWidth} ${elBCR.height - (borderWidth.value * bottomRightRatio)},
      ${elBCR.width - props.strokeWidth - (borderWidth.value * bottomRightRatio)} ${elBCR.height + borderWidth.value}, 
      ${(borderWidth.value * bottomLeftRatio) + props.strokeWidth} ${elBCR.height + borderWidth.value}, 
      ${props.strokeWidth} ${elBCR.height - (borderWidth.value * bottomLeftRatio)}, 
      ${props.strokeWidth} ${props.strokeWidth + (borderWidth.value * topLeftRatio)} `
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_btn = _resolveComponent("ui-btn")!
  const _component_ui_btn_icon = _resolveComponent("ui-btn-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onEnter: onEnter,
    onLeave: onLeave,
    appear: !__props.hover
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "root",
        ref: root,
        class: "details"
      }, [
        _createElementVNode("div", {
          class: "details-inner",
          ref_key: "panel",
          ref: panel
        }, [
          _createElementVNode("span", {
            ref_key: "background",
            ref: background,
            class: "background"
          }, [
            (_openBlock(), _createElementBlock("svg", {
              viewBox: `${backgroundData.value.viewBox.minX} ${backgroundData.value.viewBox.minY} ${backgroundData.value.viewBox.width} ${backgroundData.value.viewBox.height}`,
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("polygon", {
                points: backgroundData.value.polygon.points,
                fill: "none",
                strokeWidth: __props.strokeWidth
              }, null, 8, _hoisted_2)
            ], 8, _hoisted_1))
          ], 512),
          (__props.icon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_ui_icon, { name: __props.icon }, null, 8, ["name"])
              ]))
            : _createCommentVNode("", true),
          (__props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.title), 1))
            : _createCommentVNode("", true),
          (__props.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.description), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_ui_btn, {
            class: "btn-action",
            color: "dark-red",
            onClick: handleClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('hotspots.details.cta')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ui_btn_icon, {
            class: "btn-close",
            color: "dark",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            name: "crossmark"
          })
        ], 512)
      ], 512)
    ]),
    _: 1
  }, 8, ["appear"]))
}
}

})